import { CloseIcon } from "../../icons/close";
import { Stepper } from "../Stepper/Stepper";
import { MotifTooltip, MotifIconButton } from "../../assets/lib/motif";
import { CloseProjectHint } from "../../util/constants";
import { demoEngagementStatus } from "../../util/constants";

export function inputCustomRenderer({ steps, node }) {
  return (
    (node?.data?.isSandboxEngagement && node?.data?.setupStepID !== 4) ? (
      <div className="demo-eng-status">{demoEngagementStatus}</div>) : 
      (
        <Stepper
          steps={steps}
          size={"small"}
          stepIndex={node.data.setupStepID}
          currentStep={node.data.setupStepID}
          className={"view-engagement-stepper"}
          disableStepper={true}
        />
      )
  );
}

export function customButtonRenderer({ onDeleteEngagementClick, node }) {
  return (
    <MotifTooltip
      hideCloseButton
      hide={node.data.activeFlag === 0}
      placement="bottom"
      variant="alt"
      trigger={
        <MotifIconButton
          aria-label="Close project"
          onClick={() =>
            node.data.activeFlag !== 0
              ? onDeleteEngagementClick(node.data.id)
              : undefined
          }
          className={`view-engagement-close-project ${
            (node.data.activeFlag === 0) ? "view-engagement-link-inactive" : ""
          }`}
        >
          <CloseIcon />
        </MotifIconButton>
      }
    >
      {CloseProjectHint}
    </MotifTooltip>
  );
}

export function customTextRenderer({ node, column }) {
  return (
    <span
      className={
        node.data.activeFlag !== 0 ? "" : "view-engagement-link-inactive"
      }
    >
      {column.getColId() === "engagementCode"
        ? node.data.engagementCode
        : node.data.clientName}
    </span>
  );
}
